var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProjectCompleted(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 149,
    viewBox: "0 0 200 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "undraw_project_completed_re_jr7u 1",
    clipPath: "url(#clip0_20_3764)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M108.817 15.197C111.425 15.197 113.539 13.0828 113.539 10.4748C113.539 7.86686 111.425 5.75267 108.817 5.75267C106.209 5.75267 104.095 7.86686 104.095 10.4748C104.095 13.0828 106.209 15.197 108.817 15.197Z",
    fill: "#425CC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c-604",
    d: "M108.349 12.2762C108.243 12.2764 108.14 12.242 108.055 12.1783L108.049 12.1743L106.939 11.3254C106.723 11.1597 106.682 10.8501 106.848 10.6339C107.014 10.4178 107.323 10.3769 107.54 10.5426L108.258 11.0938L109.957 8.8778C110.123 8.66173 110.432 8.62086 110.648 8.7865L110.638 8.80125L110.649 8.78662C110.864 8.95249 110.905 9.26176 110.74 9.47792L108.742 12.0833C108.648 12.205 108.503 12.2761 108.35 12.2756L108.349 12.2762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M108.817 47.1204C111.425 47.1204 113.539 45.0062 113.539 42.3982C113.539 39.7902 111.425 37.676 108.817 37.676C106.209 37.676 104.095 39.7902 104.095 42.3982C104.095 45.0062 106.209 47.1204 108.817 47.1204Z",
    fill: "#425CC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e-605",
    d: "M108.349 44.1995C108.243 44.1997 108.14 44.1654 108.055 44.1016L108.049 44.0977L106.939 43.2487C106.723 43.083 106.682 42.7734 106.848 42.5573C107.014 42.3411 107.323 42.3002 107.54 42.4659L108.258 43.0172L109.957 40.8011C110.123 40.5851 110.432 40.5442 110.648 40.7098L110.638 40.7246L110.649 40.71C110.864 40.8758 110.905 41.1851 110.74 41.4013L108.742 44.0066C108.648 44.1283 108.503 44.1994 108.35 44.199L108.349 44.1995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M120.676 92.0188C120.618 90.5398 121.77 89.2938 123.249 89.2359C123.407 89.2297 123.565 89.2375 123.721 89.2591L128.046 80.7739L130.49 85.0775L126.008 92.4754C125.707 93.9329 124.282 94.8704 122.825 94.5696C121.605 94.3179 120.717 93.2633 120.676 92.0188Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M140.839 145.449L137.445 145.449L135.831 132.358L140.84 132.358L140.839 145.449Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M141.705 148.739L130.761 148.739V148.6C130.761 146.248 132.668 144.341 135.021 144.341H135.021L141.705 144.341L141.705 148.739Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M159.238 145.449L155.844 145.449L154.23 132.358L159.239 132.358L159.238 145.449Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M160.104 148.739L149.16 148.739V148.6C149.16 146.248 151.067 144.341 153.42 144.341H153.42L160.104 144.341L160.104 148.739Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M125.889 84.6339L124.408 87.1034C124.408 87.1034 126.877 87.1034 127.371 90.8075L129.347 88.3381L125.889 84.6339Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M151.819 79.4481C151.819 79.4481 155.77 89.8197 156.51 96.2403C157.251 102.661 158.486 119.7 158.486 119.7L160.955 141.678L154.041 142.666L151.078 120.441L144.41 98.4628L142.929 120.441L141.694 140.443L135.273 140.69L134.779 119.947L132.063 93.5239L133.545 80.9297L151.819 79.4481Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M147.003 47.9628L149.472 49.6912L152.683 82.041L132.68 82.5348L135.397 60.063L137.866 53.6424L139.649 51.2858L147.003 47.9628Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M147.497 71.1754L148.253 48.8373C148.253 48.8373 149.719 48.9505 150.213 49.6913C150.707 50.4322 158.856 51.9138 158.856 51.9138L157.375 74.8796C157.375 74.8796 163.548 93.1535 161.326 94.1413C159.103 95.1291 155.152 94.8821 155.152 94.8821L147.497 71.1754Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M135.52 68.3356L138.14 53.2806L132.31 57.2231L133.792 68.0887L132.557 75.497C132.557 75.497 127.865 95.9934 129.347 96.7342C130.828 97.475 132.557 96.7342 132.557 96.7342L135.52 75.9909V68.3356Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M134.039 56.7292L132.31 57.2231L131.569 67.1009L130.334 75.7439L124.408 86.3625C124.408 86.3625 127.371 84.387 128.606 90.0667L135.133 78.703L134.039 56.7292Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M147.471 89.9936C147.701 88.5315 149.073 87.5329 150.535 87.7632C150.691 87.7877 150.844 87.826 150.993 87.8775L156.883 80.3933L158.445 85.0895L152.613 91.4766C152.035 92.8479 150.454 93.491 149.083 92.913C147.936 92.4293 147.269 91.2224 147.471 89.9936Z",
    fill: "#FFB7B7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M157.498 87.3502L155.276 90.0667L152.312 84.8809L153.547 82.6585L157.498 87.3502Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M157.004 52.7781L158.98 51.7903C158.98 51.7903 160.462 53.7659 160.708 55.4945C160.955 57.2231 162.19 59.4456 162.19 60.6803C162.19 61.915 165.647 73.5214 165.647 73.5214L157.745 89.5728C157.745 89.5728 156.017 83.6461 152.312 83.1522L158.486 74.5092L155.029 68.3356L157.004 52.7781Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M199.751 148.891H104.729C104.591 148.891 104.479 148.78 104.479 148.642C104.479 148.504 104.591 148.393 104.729 148.393H199.751C199.888 148.393 200 148.504 200 148.642C200 148.78 199.888 148.891 199.751 148.891Z",
    fill: "#CBCBCB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M91.0314 52.873H0V31.9233H91.0314V52.873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M13.1379 38.8503C12.6481 38.8503 12.251 39.2474 12.251 39.7373C12.251 40.2271 12.6481 40.6242 13.1379 40.6242H77.8973C78.3871 40.6242 78.7842 40.2271 78.7842 39.7373C78.7842 39.2474 78.3871 38.8503 77.8973 38.8503H13.1379Z",
    fill: "#425CC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M13.1379 44.1721C12.648 44.1711 12.2501 44.5674 12.249 45.0572C12.248 45.5471 12.6443 45.945 13.1341 45.9461H54.0756C54.5655 45.9461 54.9626 45.549 54.9626 45.0591C54.9626 44.5692 54.5655 44.1721 54.0756 44.1721L13.1379 44.1721Z",
    fill: "#425CC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M91.0314 52.873H0V31.9233H91.0314V52.873ZM1.49641 51.3766H89.535V33.4197H1.49641V51.3766Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M91.0314 84.7964H0V63.8467H91.0314V84.7964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M13.1379 70.7736C12.6481 70.7736 12.251 71.1707 12.251 71.6606C12.251 72.1505 12.6481 72.5476 13.1379 72.5476H77.8973C78.3871 72.5476 78.7842 72.1505 78.7842 71.6606C78.7842 71.1707 78.3871 70.7736 77.8973 70.7736H13.1379Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M13.1379 76.0955C12.648 76.0944 12.2501 76.4907 12.249 76.9806C12.248 77.4704 12.6443 77.8684 13.1341 77.8694H54.0756C54.5655 77.8694 54.9626 77.4723 54.9626 76.9824C54.9626 76.4926 54.5655 76.0955 54.0756 76.0955H13.1379Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M91.0314 84.7964H0V63.8467H91.0314V84.7964ZM1.49641 83.2999H89.535V65.3431H1.49641V83.2999Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M91.7795 20.9497H0.748169V0H91.7795V20.9497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M13.8861 6.92696C13.3962 6.92785 12.9998 7.32568 13.0007 7.81554C13.0016 8.30414 13.3975 8.70001 13.8861 8.7009H78.6454C79.1353 8.7 79.5317 8.30217 79.5308 7.81231C79.5299 7.32371 79.134 6.92785 78.6454 6.92696H13.8861Z",
    fill: "#425CC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M13.8862 12.2488C13.3963 12.2478 12.9983 12.644 12.9973 13.1339C12.9963 13.6237 13.3926 14.0217 13.8824 14.0227H54.8239C55.3138 14.0236 55.7116 13.6272 55.7125 13.1374C55.7134 12.6475 55.317 12.2497 54.8272 12.2488C54.8261 12.2488 54.825 12.2488 54.8239 12.2488L13.8862 12.2488Z",
    fill: "#425CC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M91.7795 20.9497H0.748169V0H91.7795V20.9497ZM2.24458 19.4533H90.2831V1.49641H2.24458V19.4533Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M184.369 149.007V130.965C184.369 130.965 191.4 143.756 184.369 149.007Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M184.804 149.003L171.513 136.802C171.513 136.802 185.69 140.273 184.804 149.003Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    d: "M120.788 91.4752C123.396 91.4752 125.511 89.361 125.511 86.753C125.511 84.1451 123.396 82.0309 120.788 82.0309C118.18 82.0309 116.066 84.1451 116.066 86.753C116.066 89.361 118.18 91.4752 120.788 91.4752Z",
    fill: "#425CC7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g-606",
    d: "M120.32 88.5544C120.214 88.5546 120.111 88.5202 120.026 88.4565L120.021 88.4525L118.911 87.6036C118.695 87.4379 118.654 87.1283 118.819 86.9122C118.985 86.696 119.295 86.6551 119.511 86.8208L120.23 87.3721L121.928 85.156C122.094 84.94 122.403 84.8991 122.62 85.0647L122.609 85.0795L122.62 85.0648C122.836 85.2307 122.877 85.54 122.711 85.7561L120.713 88.3615C120.619 88.4832 120.474 88.5543 120.321 88.5539L120.32 88.5544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M140.06 48.3721C143.793 48.3721 146.82 45.3458 146.82 41.6126C146.82 37.8794 143.793 34.8531 140.06 34.8531C136.327 34.8531 133.301 37.8794 133.301 41.6126C133.301 45.3458 136.327 48.3721 140.06 48.3721Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M145.965 46.8061C145.965 46.8061 147.967 42.7515 147.931 41.2036C147.896 39.6556 146.802 35.6723 146.34 35.4096C145.879 35.1469 140.901 32.6196 139.552 33.3795C138.203 34.1393 135.829 36.7384 133.268 37.4416C132.544 37.6405 133.176 41.3612 133.176 41.3612L136.173 40.9277C136.173 40.9277 139.297 38.1227 139.432 40.0328C139.567 41.9428 142.464 41.1473 142.464 41.1473L142.5 42.6952L143.685 42.759L144.012 41.1116C144.012 41.1116 144.545 44.4702 143.856 46.217C143.168 47.9638 145.965 46.8061 145.965 46.8061Z",
    fill: "#2F2E41"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_3764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 149.007,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCompleted);
export default __webpack_public_path__ + "static/media/project_completed.db2e1e131d479d9c1d34206fd74ea243.svg";
export { ForwardRef as ReactComponent };